<template>
    <div class="grid place-items:center min-height:100dvh {bg:white}@xs {bg:gray50}@md">
        <div class="bg:white r:8px w:100% flex flex:col ai:stretch jc:center gap:32 {p:16}@xs {w:416;h:693;b:1px|solid|gray300;p:64|48}@md">
            <uniai-logo></uniai-logo>
            <slot></slot>
        </div>
    </div>
</template>
